/**
 * Ordered by how much the visitor saw, most serious first; `hydration` split out of `recoverable` for TEC-3748.
 * A leaf with no imports: the portals browser bundle imports it, and the barrel would drag in `node:crypto`.
 * The zod enum in `portals/src/lib/data.ts` and the Jira select option must agree: that enum has no
 * `.catch()`, so an unlisted value loses the whole report.
 */
export const CLIENT_ERROR_SOURCES = [
	'uncaught',
	'boundary',
	'unhandledrejection',
	'global',
	'hydration',
	'recoverable',
] as const;

export type ClientErrorSource = (typeof CLIENT_ERROR_SOURCES)[number];
